import {ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, Optional} from '@angular/core';
import {BlockWidth, Image} from '@paperlessio/sdk/api/models';
import {BLOCKS_CONFIG, BlocksConfig} from '../blocks.config';
import {BlockMutationService} from '@blocks/services/block-mutation/block-mutation.service';
import {BlockComponent} from '@blocks/block/block.component';
import {UploadService} from '@shared/services/upload.service';
import {ToastService} from '@paperlessio/sdk/api/util';
import {UploadBlockComponent} from '@blocks/upload/upload.component';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent extends UploadBlockComponent implements OnInit, OnDestroy {
  @Input() block: Image;

  constructor(
    protected blockMutationService: BlockMutationService,
    protected toast: ToastService,
    protected uploadService: UploadService,
    protected cdr: ChangeDetectorRef,
    @Inject(BLOCKS_CONFIG) public blocksConfig: BlocksConfig,
    @Optional() public blockComponent: BlockComponent) {
    super(uploadService, blockMutationService, toast, cdr);
  }

  ngOnInit() {
    super.init();
  }

  ngOnDestroy(): void {
    super.destroy();
  }

  /**
   * Gets called once the preview image has loaded the local blob the user selected.
   * This method is used to get the original dimensions of the image and set the width
   * to a lower value if the image is smaller than 940px.
   * @param event
   */
  public previewImageLoaded(event) {
    this.setImageSize(event);

    // TODO: @2x => Größe halbieren

    if (!this.block.styles.width && this.block.settings.naturalWidth < 940) {
      this.block.styles.width = new BlockWidth({value: this.block.settings.naturalWidth, unit: 'pixel'});
    } else if (!this.block.styles.width) {
      this.block.styles.width = new BlockWidth({value: 940, unit: 'pixel'});
    }
  }

  public imageLoaded(event) {
    this.setImageSize(event);

    if (this.uploadingBlob?.uploadTrustedLocalFileUrl) {
      this.uploadingBlob.uploadTrustedLocalFileUrl = undefined;
    }

    this.previewEnabled = false;
  }

  private setImageSize(event) {
    let imageElement = event?.srcElement;
    if (event?.path && event?.path.length > 0 && event?.path[0]?.tagName === 'IMG') {
      imageElement = event?.path[0];
    }

    this.block.settings.naturalHeight = imageElement.naturalHeight;
    this.block.settings.naturalWidth = imageElement.naturalWidth;
    this.block.calculateAspectRatio(true);
    this.cdr.markForCheck();
  }

  protected reset() {
    super.reset();
    this.block.calculateAspectRatio();
  }
}
